import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { ThemeProvider } from "./lib/theme";

// Legacy footgun: an inference key used to be cached in the browser. Purge it before anything mounts.
window.localStorage.removeItem("aegis_gemini_key");

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ThemeProvider>
    <App />
  </ThemeProvider>
);
